import { DataCollectionInterface } from '../../interfaces/data-collection.interface';

export class LoadDataCollectionsSuccess {
    public static readonly type = '[DataCollection] Load data collections success';

    constructor(
        public dataCollections: Array<DataCollectionInterface>,
    ) { }
}
